import './bellinisristorante/style';
import FormStructure from './bellinisristorante/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js